export const apiConstants = {
    base_url : "https://admin.parkingpal.app/"
};